import { render, staticRenderFns } from "./parcel.vue?vue&type=template&id=362e5ec9&"
import script from "./parcel.vue?vue&type=script&lang=js&"
export * from "./parcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports